import React from 'react';
import { PRIORITY_CONFIG } from './taskConfigs';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const CalendarGrid = ({ calendarYear, calendarMonth, setCalendarYear, setCalendarMonth, calendarData }) => {
  const daysInMonth = new Date(calendarYear, calendarMonth, 0).getDate();
  const firstDow = new Date(calendarYear, calendarMonth - 1, 1).getDay();
  const today = new Date().toISOString().split('T')[0];
  const days = [];
  for (let i = 0; i < firstDow; i++) days.push(null);
  for (let d = 1; d <= daysInMonth; d++) days.push(d);
  const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-testid="calendar-view">
      <div className="flex items-center justify-between px-5 py-3 text-white" style={{ background: 'linear-gradient(135deg, #D97706 0%, #EA580C 100%)' }}>
        <button onClick={() => { if (calendarMonth === 1) { setCalendarMonth(12); setCalendarYear(y => y - 1); } else setCalendarMonth(m => m - 1); }} data-testid="calendar-prev"><ChevronLeft className="w-5 h-5" /></button>
        <span className="font-semibold">{monthNames[calendarMonth - 1]} {calendarYear}</span>
        <button onClick={() => { if (calendarMonth === 12) { setCalendarMonth(1); setCalendarYear(y => y + 1); } else setCalendarMonth(m => m + 1); }} data-testid="calendar-next"><ChevronRight className="w-5 h-5" /></button>
      </div>
      <div className="grid grid-cols-7 text-center text-xs font-medium text-gray-500 border-b">
        {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d => <div key={d} className="py-2">{d}</div>)}
      </div>
      <div className="grid grid-cols-7">
        {days.map((d, i) => {
          if (!d) return <div key={`e${i}`} className="min-h-[80px] border-r border-b border-gray-100" />;
          const dateStr = `${calendarYear}-${String(calendarMonth).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
          const dayTasks = calendarData[dateStr] || [];
          const isToday = dateStr === today;
          return (
            <div key={d} className={`min-h-[80px] border-r border-b border-gray-100 p-1 ${isToday ? 'bg-amber-50' : ''}`}>
              <div className={`text-xs font-medium mb-0.5 ${isToday ? 'text-white w-5 h-5 rounded-full flex items-center justify-center' : 'text-gray-600'}`} style={isToday ? { background: 'linear-gradient(135deg, #D97706 0%, #EA580C 100%)' } : {}}>{d}</div>
              {dayTasks.slice(0, 3).map(t => (
                <div key={t.id} className={`text-[9px] px-1 py-0.5 rounded mb-0.5 truncate cursor-pointer ${PRIORITY_CONFIG[t.priority]?.bg || 'bg-gray-50'} ${PRIORITY_CONFIG[t.priority]?.text || ''}`} title={t.title}>{t.title}</div>
              ))}
              {dayTasks.length > 3 && <div className="text-[9px] text-gray-400 px-1">+{dayTasks.length - 3} more</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};
